export default __webpack_public_path__ + "static/media/me.a52e6d2d.jpg";